






























import { Component, Prop, Vue } from 'vue-property-decorator'
import { Question, Response } from '@/store/modules/survey-store-module'
import PlaceholderSvg from '@/assets/img/Typewriter.svg?inline'

import ResponsesByQuestion from './ResponsesByQuestion.vue'

@Component({
  components: {
    ResponsesByQuestion,
    PlaceholderSvg
  }
})
export default class ResponsesByQuestions extends Vue {
  @Prop({ required: true }) questions!: Question[]
  @Prop({ required: true }) readonly respondentRemovalMap!: Record<string, boolean>
  @Prop({ required: true }) readonly responseRemovalMap!: Record<string, boolean>

  scrollToQuestion (idx: number) {
    const targetQuestion = (this.$refs[idx] as Vue[])[0].$el
    targetQuestion.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      inline: 'nearest'
    })
  }

  toggleResponseRemoval (payload: { response: Response, shiftClick: boolean }) {
    this.$emit('toggleResponseRemoval', payload)
  }

  setAllResponses (responseIds: string[], show: boolean) {
    this.$emit('setAllResponses', responseIds, show)
  }
}
